import { ApolloCache } from '@apollo/client';

export const clearEquipmentCache = (cache: ApolloCache<any>) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'equipmentStats',
  });
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'equipmentCount',
  });
  cache.gc();
};

export const clearCableCache = (cache: ApolloCache<any>) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'cableStats',
  });
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'cableCount',
  });
  cache.gc();
};

export const clearRacewayCache = (cache: ApolloCache<any>) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'racewayStats',
  });
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'racewayCount',
  });
  cache.gc();
};

export const clearJumperCache = (cache: ApolloCache<any>) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'jumperStats',
  });
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'jumperCount',
  });
  cache.gc();
};

export const clearCableCodeCache = (cache: ApolloCache<any>) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'cableCodeCount',
  });
  cache.gc();
};

export const clearRacewayCodeCache = (cache: ApolloCache<any>) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'racewayCodeCount',
  });
  cache.gc();
};

export const clearEquipmentCodeCache = (cache: ApolloCache<any>) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'equipmentCodeCount',
  });
  cache.gc();
};

export const clearPackageCache = (cache: ApolloCache<any>) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'packageCount',
  });
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'associatedPackagesByPackageId',
  });
  cache.gc();
};

export const clearFireAreaCache = (cache: ApolloCache<any>) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'fireAreaCount',
  });
  cache.gc();
};

export const clearColorCodeCache = (cache: ApolloCache<any>) => {
  cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'colorCodeCount',
  });
  cache.gc();
};
